<template>
  <div>
    <div class="field">
      <div :class="['control', 'has-icons-right', {'is-loading': is_loading}]">
        <input style="display:none;" type="text"  />
        <input autocomplete="off" :value="searchString" @input="searchString=$event.target.value" @keyup.enter="forwardSearch(searchString)" @keyup="orgLookup()" class="input" type="text" name="search" :placeholder="placeHolder" />
        <span class="icon is-small is-right"><i class="fas fa-search"></i></span>
        <!-- orgs lookup dropdown -->
        <div :class="['dropdown', showOrgLookDropdown]" v-show="orgsFound">
          <div class="dropdown-menu" role="menu">
            <div class="dropdown-content is-paddingless" @mouseleave.self="hideBusinessAutoComplete">
              <a v-for="business in businesses" @click.prevent="selectOrg(business)" href="#" :ref="`${business.id}`" class="dropdown-item has-text-left" v-html="business.name"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import search from '@/mixins/search.js'
  import ApiResource from '@/api/ApiResource.js'

  export default {
    name: 'BusinessSearch',
    mixins: [search],
    props: {
      placeHolder: {
        type: String,
        default: 'Search for businesses...'
      }
    },
    data () {
      return {
        searchString: '',
        org_selected: false,
        show_dropdown: false,
        on_blur_close: false,
        is_loading: false,
        drop_down_opened: false,
        businesses: [],
        business_available: false
      }
    },
    computed: {
      orgsFound () {
        return this.businesses.length > 0
      },
      showOrgLookDropdown () {
        if (this.on_blur_close && !this.org_selected) {
          return ''
        }
        if ((this.org_selected || this.businesses.length > 0) && !this.on_blur_close) {
          return 'is-active'
        }
      },
    },
    methods: {
      orgLookup () {
        this.org_selected = false
        this.show_dropdown = false
        this.on_blur_close = false
        if (this.searchString.length < 3) {
          this.businesses = []
          this.show_dropdown = false
        }
        else {
          this.is_loading = true
          let keyword = encodeURIComponent(this.searchString.trim())
          new ApiResource({}).send(`/search/business?name=${keyword}`, {}, 'get')
            .then((businesses) => {
              if (businesses.length === 0) {
                this.businesses = []
                this.org_selected = true
                this.show_dropdown = false
                this.drop_down_opened = false
                this.is_loading = false
              } else {
                this.drop_down_opened = true
                this.businesses = businesses
                this.is_loading = false
              }
            })
            .catch(() => {
              this.is_loading = false
              this.drop_down_opened = false
            })
        }
      },
      hideBusinessAutoComplete () {
        try {
          this.searchString = this.searchString.trim()
          this.drop_down_opened = true
          this.on_blur_close = true
          const parent = this
          parent.business_available = false
          this.businesses.forEach((business) => {
            let inlist = false
            if (this.searchString.toLowerCase() === business.name.toLowerCase() && !inlist) {
              if (business.status === 'ACTIVE') {
                parent.business_available = false
                parent.org_selected = true
                parent.drop_down_opened = false
              }
              else if (!inlist) {
                inlist = true
                parent.org_selected = true
                parent.business_available = true
                parent.drop_down_opened = false
              }
            }
            if (this.searchString.toLowerCase() !== business.name.toLowerCase() && !inlist) {
              parent.business_available = true
              parent.drop_down_opened = false
              parent.org_selected = true
            }
          })
        } catch (e) {}
      },
      selectOrg (business) {
        this.org_selected = true
        this.businesses = []
        this.drop_down_opened = false
        this.$router.push(`/${business.slug}`)
        window.location.reload()
      }
    }
  }
</script>
<style scoped>

  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #8A8C91;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #8A8C91;
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: #8A8C91;
  }

  .input {
    color: #58595B;
    border: none;
    border-radius: 0;
    font-size: 0.8rem;
    height: 40px;
    padding-left: 1rem;
  }

  .icon {
    color: #2EAAE1!important;
    font-size: 0.9rem;
    height: 40px!important;
  }

  .dropdown {
    display: block;
    width: 100%;
  }

  .dropdown-trigger {
    text-align: left;
    width: 100%;
  }

  .button-dropdown {
    text-align: left;
    justify-content: left;
    min-width: 100%;
    color: #8A8C91 !important;
    background-color: #fff !important;
    border-color: #dbdbdb !important;
    min-height: 39px !important;
  }

  .dropdown-menu {
    border-top: 3px solid #30AAE1;
    width: 100%;
    padding-top: 0 !important;
    border-bottom: 1px solid #e1dfdf;
  }

  .fa-angle-down {
    font-size: 1.4rem;
  }

  .fa-angle-down:before {
    right: 0.7em;
  }

  .fa-angle-down:before {
    border: 1px solid #95979b;
    border-right: 0;
    border-top: 0;
    content: " ";
    display: block;
    height: 0.5em;
    pointer-events: none;
    position: absolute;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform-origin: center;
    transform-origin: center;
    width: 0.5em;
    margin-top: -0.375em;
    right: 1.125em;
    top: 50%;
    z-index: 4;
  }

  a.dropdown-item:hover {
    background-color: #30AAE1;
    color: #fff;
  }

  .dropdown-item {
    padding: 10px !important;
    border: 1px solid transparent;
  }

  .dropdown-content {
    border-radius: 0;
    overflow-y: scroll;
    height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/BusinessSearch.vue